
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-societies",
      function () {
        return require("private-next-pages/student-societies/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-societies"])
      });
    }
  